import { getShellConfig } from '@src/config/shell/config';
import { Logo } from '@src/config/shell/localConfigTypes';
import { Brand } from '@superbet-group/web.lib.ui-components';
import { NavigationContext } from '@superbet-group/web.types';

export function getCurrentBrand(currentNavigationContext: NavigationContext): Brand {
    const brand = getShellConfig().localConfig.logo;
    if (brand === Logo.Superbet) {
        return currentNavigationContext === NavigationContext.Sports ? Brand.Sports : Brand.Gaming;
    } else {
        return currentNavigationContext === NavigationContext.Sports ? Brand.NapoleonSports : Brand.NapoleonGaming;
    }
}
